

import {Options, Vue} from "vue-class-component";
import ModuleSettings from "@/store/settings";
import {
    CabinetAssignedSpecialistDto,
    CabinetAssignedSpecialistRs,
    CareerHighlight,
    EducationHighlight
} from "@/types/assignedSpecialist";
import ModuleAuth from "@/store/auth";
import {SetPasswordRq} from "@/types/auth";
import rules from '@/utils/rules';

@Options({
})
export default class Settings extends Vue {
    private tab: string = 'profile';
    private valid: boolean = false;
    private avatarUrl: string | ArrayBuffer = ''; // Placeholder for avatar URL
    private careerHeaders: any = [
        { text: 'Time Period', value: 'timePeriod' },
        { text: 'Place', value: 'place' },
        { text: 'Title', value: 'title' },
        { text: 'Subtitle', value: 'subtitle' },
        { text: 'Actions', value: 'actions', sortable: false },
    ];
    private localeItems = [
        {locale: 'en', localeTitle: '🇬🇧 English'},
        {locale: 'ru', localeTitle: '🇷🇺 Russian'},
        {locale: 'be', localeTitle: '🇧🇾 Belarussian'},
        {locale: 'de', localeTitle: '🇩🇪 German'},
        {locale: 'it', localeTitle: '🇮🇹 Italian'},
        {locale: 'es', localeTitle: '🇪🇸 Spanish'},
        {locale: 'pt', localeTitle: '🇵🇹 Portuguese'},
        {locale: 'ar', localeTitle: '🇸🇦 Arabic'},
        {locale: 'zh', localeTitle: '🇨🇳 Chinese'},
        {locale: 'pl', localeTitle: '🇵🇱 Polish'},
    ];
    private educationHeaders: any = [
        { text: 'Time Period', value: 'timePeriod' },
        { text: 'Place', value: 'place' },
        { text: 'Title', value: 'title' },
        { text: 'Subtitle', value: 'subtitle' },
        { text: 'Actions', value: 'actions', sortable: false },
    ];
    private rules: any = {
        newPassword: [
            rules.passwordRequired,
            rules.minimalLengthPassword,
        ],
        newRepeatedPassword: [
            rules.passwordRequired,
            rules.minimalLengthPassword,
            () => this.newPassword === this.newRepeatedPassword || 'Passwords don\'t match'
        ]
    };
    private specialist: CabinetAssignedSpecialistDto = {
        name: '',
        title: '',
        rating: 0,
        experience: '',
        sessionTime: '',
        tags: [],
        reviews: 0,
        priceTag: '',
        description: '',
        avatarUrl: '',
        url: '',
        career: [],
        education: [],
        price: {
            amount: 0,
            currency: '',
            fee: 0
        },
        serviceAgreementUrl: '',
        articlesCount: 0,
        enabled: false,
        localesToSpeak: []
    }
    private newPassword: string = null;
    private newRepeatedPassword: string = null;
    private passwordFormValid: boolean = false;
    private loading: boolean = false;
    private show: boolean = false;

    async mounted() {
        this.specialist = await ModuleSettings.getAssignedSpecialist();
    }

    updateAvatar(event) {
        const target = event.target;
        if (target.files && target.files.length > 0) {
            const file = target.files[0];
            const reader = new FileReader();
            reader.onload = (e) => {
                this.avatarUrl = e.target.result; // Update avatar URL
            };
            reader.readAsDataURL(file);
        }
    }

    saveProfile() {
        // Implement the save logic here
        console.log('Profile saved:', this.specialist);
        // Optionally, make an API call to save the data
    }

    addCareer() {
        const newCareer: CareerHighlight = {
            logoUrl: '',
            title: '',
            subtitle: '',
            place: '',
            certificateUrl: ''
        };
        this.specialist.career.push(newCareer);
    }

    removeCareer(item) {
        const index = this.specialist.career.indexOf(item);
        if (index > -1) {
            this.specialist.career.splice(index);
        }
    }

    addEducation() {
        const newEducation: EducationHighlight = {
            logoUrl: '',
            title: '',
            subtitle: '',
            place: '',
            certificateUrl: ''
        };
        this.specialist.education.push(newEducation);
    }

    removeEducation(item) {
        const index = this.specialist.education.indexOf(item);
        if (index > -1) {
            this.specialist.education.splice(index);
        }
    }

    async onChangePassword() {
        if (!this.passwordFormValid) return;
        this.loading = true;

        const password: SetPasswordRq = {
            password: this.newPassword
        }

        await ModuleAuth.changePassword(password);
        this.loading = false
    }
 }
